/**
 * Federated Components Registry for this microsite (PM-312)
 *
 * Remote URLs are resolved at RUNTIME from the moduleFederation context
 * (settings.json -> configserver -> context -> bootstrap), following the same
 * pipeline as featureFlags and preferences. The static __remotes from the
 * webpack config is kept as a build-time fallback but is overridden at server
 * startup by bootstrap.js with runtime-resolved URLs.
 */

const { getServerRemoteConfig } = require('../webpack/module-federation-config');
const { yodaSiteComponents } = require('./yodaSiteComponents');

/**
 * Parses server remote configuration and extracts URLs
 * Handles both "name@url" (build-time) and plain URL (runtime) forms.
 * @param {Object} [serverConfig] - Optional runtime remote config
 * @returns {Object} Parsed remote configuration with URLs only
 */
const parseServerRemotes = (serverConfig) => {
    const config = serverConfig || getServerRemoteConfig();
    const parsed = {};

    Object.entries(config).forEach(([key, value]) => {
        // Split on the FIRST @ only — the URL itself may contain one.
        if (typeof value === 'string' && value.includes('@')) {
            const at = value.indexOf('@');
            parsed[key] = value.slice(at + 1) || value;
        } else {
            parsed[key] = value;
        }
    });

    return parsed;
};

/**
 * Mutable remotes store.
 * Initialized with build-time defaults from webpack config.
 * Overridden at runtime by bootstrap.js with context-resolved URLs.
 */
let _remotes = parseServerRemotes();

export const federatedComponents = {
    ...yodaSiteComponents,
    get __remotes() {
        return _remotes;
    },
    set __remotes(value) {
        _remotes = value;
    },
};

/**
 * Sets runtime remote URLs from the moduleFederation context.
 * Called by bootstrap.js during server startup and on config refresh.
 *
 * @param {Object} remoteConfig - Remote config object (name -> URL mappings)
 */
export const setRuntimeRemotes = (remoteConfig) => {
    if (remoteConfig && typeof remoteConfig === 'object' && Object.keys(remoteConfig).length > 0) {
        _remotes = parseServerRemotes(remoteConfig);
    }
};
